<template>
    <form action="" class="" v-on:submit.prevent="createClassification">
        <FormErrors :errors="vuelidate.$errors" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.classification.name.$model" v-model="vuelidate.classification.name.$model" />
        <InputComponent type="textarea" placeholder="Descripción" :value="vuelidate.classification.description.$model" v-model="vuelidate.classification.description.$model" />
        <SelectInput placeholder="Padre" :items="classifications" :value="vuelidate.classification.parent_id.$model" v-model="vuelidate.classification.parent_id.$model" />
        <SelectInput placeholder="Principal" :items="[{id:'0',name:'no'},{id:'1',name:'si'}]" :value="vuelidate.classification.principal.$model" v-model="vuelidate.classification.principal.$model" />
        <SelectInput placeholder="Tipo" :items="[{id:'VITA',name:'VITA'},{id:'DOMINIO',name:'DOMINIO'},{id:'REINO',name:'REINO'},{id:'DIVISIÓN',name:'DIVISIÓN'},{id:'CLASE',name:'CLASE'},{id:'ORDEN',name:'ORDEN'},{id:'FAMILIA',name:'FAMILIA'},{id:'GENERO',name:'GENERO'},{id:'ESPECIE',name:'ESPECIE'}]" :value="vuelidate.classification.type.$model" v-model="vuelidate.classification.type.$model" />
        <SubmitButtonComponent value="Guardar"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import useNotification from '../../Services/useNotification'
import SelectInput from '../Forms/SelectInput.vue'

export default {
    components: {InputComponent,SubmitButtonComponent,FormErrors,SelectInput},
    props: ['classification','classifications'],
    validations() {
        return {
            classification: {
                name: {
                    required
                },
                description: {},
                parent_id:{

                },
                principal: {},
                type: {}
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const classification= ref(props.classification)
        const isEdit = classification.value.name!=''
        const notificate = useNotification()

        const createClassification = async()=>{
            let validation = await vuelidate.value.$validate();

            if(validation){
                let apiCall = null
                if(isEdit){
                    apiCall = api.updateClassification(classification.value)
                }else{
                    apiCall = api.addClassification(classification.value)
                }
                apiCall.then(response=>{
                    console.log(response)
                    notificate.success('Clasificacion Creada con exito')
                    Inertia.reload()
                    emit('added')
                })
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        return{
            classification,
            createClassification,
            vuelidate
        }
    }
}
</script>

<style>

</style>